import { render } from "./ProductAndPriceManager.vue?vue&type=template&id=4a220072"
import script from "./ProductAndPriceManager.vue?vue&type=script&lang=js"
export * from "./ProductAndPriceManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__